import UserTeamSettingsStore from "../store";

/**
 * Checks if a user has muted a specific schedule group.
 *
 * Encapsulates the "default to false" logic: schedule groups are unmuted by default
 * unless explicitly muted. This centralizes the lookup logic and prevents
 * inconsistent defaults across the codebase.
 *
 * @param teamId - The team ID
 * @param scheduleGroupId - The schedule group ID
 * @returns true if muted, false if not muted (default)
 *
 * @example
 * ```typescript
 * const muted = isMuted(teamId, scheduleGroupId);
 * const icon = muted ? "alert-off-20X20" : "alert-on-20X20";
 * ```
 *
 * DESIGN RATIONALE:
 * - Default to false: New groups are automatically unmuted (opt-in model for muting)
 * - Uses derived cache (muteScheduleGroupStatusByTeamAndGroup) for O(1) lookup
 * - Cache is rebuilt from mutedScheduleGroupIds by setUserTeamSettingsForTeam mutator
 */
export function isMuted(teamId: string, scheduleGroupId: string): boolean {
    const store = UserTeamSettingsStore();
    const muteStatusMap = store.muteScheduleGroupStatusByTeamAndGroup.get(teamId);

    // Default to false: groups are unmuted unless explicitly marked as muted
    return muteStatusMap?.get(scheduleGroupId) ?? false;
}
